import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'
import Select from 'react-select'
import { workStagesLibraryAPI } from '../../services/api'

const AddWorkStageModal = ({ show, onHide, onAdd }) => {
  const [workStages, setWorkStages] = useState([])
  const [selectedStages, setSelectedStages] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (show) {
      loadWorkStages()
    }
  }, [show])

  const loadWorkStages = async () => {
    try {
      setLoading(true)
      const response = await workStagesLibraryAPI.list()
      const options = response.data.map((ws) => ({
        value: ws.id,
        label: ws.name,
      }))
      setWorkStages(options)
      setError(null)
    } catch (err) {
      setError('Ошибка загрузки этапов работ')
      console.error('Error loading work stages:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (selectedStages.length === 0) {
      setError('Выберите хотя бы один этап')
      return
    }

    const ids = selectedStages.map((s) => s.value)
    onAdd(ids)
    handleClose()
  }

  const handleClose = () => {
    setSelectedStages([])
    setError(null)
    onHide()
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Добавить этапы работ</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          <Form.Group className="mb-3">
            <Form.Label>Выберите этапы работ *</Form.Label>
            <Select
              isMulti
              options={workStages}
              value={selectedStages}
              onChange={setSelectedStages}
              placeholder="Начните вводить название этапа..."
              noOptionsMessage={() => 'Этапы не найдены'}
              loadingMessage={() => 'Загрузка...'}
              isLoading={loading}
              isDisabled={loading}
              className="react-select-container"
              classNamePrefix="react-select"
            />
            <Form.Text className="text-muted">
              Вы можете выбрать несколько этапов. Они будут добавлены к проекту.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Отмена
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={loading || selectedStages.length === 0}
          >
            Добавить
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddWorkStageModal
